import { type IAgentRegistrationProfileInfoQuery } from 'application/querySchemas/IAgentRegistrationProfileInfoQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import {
    type IAgentRegistrationProfileInfoClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IAgentRegistrationProfileInfoClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentRegistrationProfileInfoQuery implements IAgentRegistrationProfileInfoQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentRegistrationProfileInfoClient')
        public readonly agentRegistrationProfileInfoClient: IAgentRegistrationProfileInfoClient,
    ) {}

    public async fetch(): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentRegistrationProfileInfoClient.get({
            token: this.agentUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
